<template>
  <BgSelector v-model="section.bg" :availableTypes="availableTypes" :disabled="hasBindedStyle">
    <template v-if="showField('height')" slot="col">
      <div class="_pr">
        <TextField 
          v-model="selectedSection.bg.height"
          label="Altura"
          type="number"
          :minValueForNumber="minValueForNumber"
        />
      </div>
    </template>
  </BgSelector>
</template>

<script>
import TextField from '../../../_v2/ui/TextField.vue'
import BgSelector from '../../../_v2/utils/BgSelector.vue'

export default {
  name: 'Background',
  components: { TextField, BgSelector },
  props: {
    selectedSection: {type: Object, required: true},
    sectionType: {type: String, required: true},
    availableTypes: {type: Array, default: () => ['color', 'image', 'video']},
    hide: {type: Array, default: () => ([])}, // ['height'] 
    minValueForNumber: {type: Number, default: 300}
  },

  computed: {
    section: {
      get () { return this.selectedSection },
      set (v) { 
        this.$emit('update', v) 
      }
    },

    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    }    
  },

  methods: {
    showField (type) {
      return !this.hide.includes(type)
    }    
  }
}
</script>